<span>{{ 'auth.error_message_no_permission' | translate }}</span>

<rd-shared-button
  class="close-button-wrapper"
  [buttonClass]="'close-button'"
  [buttonContent]="buttonContent"
  [buttonTheme]="'outline-primary'"
  (clickFn)="close()">
  <ng-template #buttonContent>
    <span class="continue-button-text"> {{ 'modal.close' | translate }} </span>
  </ng-template>
</rd-shared-button>
